import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateNoteSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 30,
	viewBox: "0 0 31 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.76 15.48H19.44",
			stroke: "black",
			strokeWidth: 1.92,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.76 19.32H19.44",
			stroke: "black",
			strokeWidth: 1.92,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.96 4.92H24.24C24.4946 4.92 24.7388 5.02114 24.9188 5.20118C25.0989 5.38121 25.2 5.62539 25.2 5.88V24.12C25.2 24.8838 24.8966 25.6164 24.3565 26.1565C23.8164 26.6966 23.0838 27 22.32 27H8.88C8.11618 27 7.38364 26.6966 6.84353 26.1565C6.30343 25.6164 6 24.8838 6 24.12V5.88C6 5.62539 6.10114 5.38121 6.28118 5.20118C6.46121 5.02114 6.70539 4.92 6.96 4.92Z",
			stroke: "black",
			strokeWidth: 1.92,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.84 3V6.84",
			stroke: "black",
			strokeWidth: 1.92,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6 3V6.84",
			stroke: "black",
			strokeWidth: 1.92,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.36 3V6.84",
			stroke: "black",
			strokeWidth: 1.92,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCreateNoteSymbol;
